import React, { useEffect, useRef, useState } from "react";
import SimpleBar from "simplebar-react";
import axios from "axios";
import apiUrl, { localPath } from "slices/apiEndpoint";
import { getDecodeId, getUserName } from "slices/userProfile/thunk";
import { Container } from "react-bootstrap";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import HomeownerSearchModal from "./homeOwnerSearchModal";
import { CallAPIGetPromise, CallAPITESTGetPromise } from "Common/commaon";
import SubContractorSelection from "./subContractor";
import api from "Common/api";

interface Message {
  id: string;
  sender: "user" | "ai";
  body: string;
  time: string;
}

interface Homeowner {
  id: string;
  user_first_name: string;
  user_email: string;
}
interface subContractor {
  id: string;
  user_first_name: string;
  user_email: string;
}

const AIContractChatScreen: React.FC = () => {
  const userId = getDecodeId();
  const userName = getUserName();
  const [decodedJwt, setDecodedJwt] = useState<string>("");
  const [messages, setMessages] = useState<Message[]>([]);
  const [messageInput, setMessageInput] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [isHomeownerStepCompleted,setIsHomerOwnerStepCompleted] = useState(false)
const [showHomeownerModal,setShowHomeownerModal] = useState(false)
const [showSubContractorModal,setShowSubContractorModal] = useState(false)
const [isAwaitingSubContractrSelection,setAwaitingSubContractrSelection] = useState(false)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const decodedToken = decodeJwt();
    if (decodedToken) {
      setDecodedJwt(decodedToken.userType);
    } else {
      console.error("Decoded token is null");
    }
  }, []);

  useEffect(() => {
    setMessages([
      {
        id: "welcome",
        sender: "ai",
        body: "👋 Hey! I’ll help you generate a contract. Let’s start with the homeowner’s name or email. Or type 'skip' if you want to add it later.",
        time: getTime(),
      },
    ]);
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const getTime = () =>
    new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });



  const handleHomeownerSelect = async (homeowner: Homeowner) => {
    setIsHomerOwnerStepCompleted(true)
    const userMessage: Message = {
      id: `user-${Date.now()}`,
      sender: "user",
      body: `Selected homeowner: ${homeowner.user_first_name} (${homeowner.user_email})`,
      time: getTime(),
    };
    setMessages((prev) => [...prev, userMessage]);

    await sendChat(`Selected homeowner ID: ${homeowner.id}`);
  };
  const hanldeSubContractorSelection = async (subContractor: subContractor) => {
    setAwaitingSubContractrSelection(false)

    const userMessage: Message = {
      id: `user-${Date.now()}`,
      sender: "user",
      body: `Selected SubContractor: ${subContractor.id} (${subContractor.user_first_name})`,
      time: getTime(),
    };
    setMessages((prev) => [...prev, userMessage]);

    await sendChat(`Selected SubContractor ID: ${subContractor.id}`);
  };

  const sendChat = async (text: string) => {
    try {
      const res = await api.post(`/api/tradesmensAI/chat`, {
        userId,
        userName,
        message: text,
      });
      const parsedReply = JSON.parse(res.data.reply);
      if(parsedReply?.type==="text"){
        const aiReply: Message = {
          id: `ai-${Date.now()}`,
          sender: "ai",
          body: parsedReply.message,
          time: getTime(),
        };
      setMessages((prev) => [...prev, aiReply]);

      }
 
      if (parsedReply.type === "trigger" &&parsedReply.message  === "TRIGGER_SHOW_CONTRACT_SUMMARY") {
        const summaryMessage: Message = {
          id: `ai-json-${Date.now()}`,
          sender: "ai",
          body: `📄 Here's your contract summary:\n\n\`\`\`json\n${JSON.stringify(
            res.data.contract,
            null,
            2
          )}\n\`\`\``,
          time: getTime(),
        };
        setMessages((prev) => [...prev, summaryMessage]);
      }else{
        if(parsedReply.type === "trigger" &&parsedReply.message  === "TRIGGER_SEARCH_SUBCONTRACTOR"){
        setAwaitingSubContractrSelection(true)
        
        }
      }
    } catch (err) {
      console.error("Chat error:", err);
      setMessages((prev) => [
        ...prev,
        {
          id: `ai-${Date.now()}`,
          sender: "ai",
          body: "⚠️ Something went wrong. Please try again later.",
          time: getTime(),
        },
      ]);
    }
  };

  const sendMessage = async () => {
    if (!messageInput.trim()) return;

    const userMessage: Message = {
      id: `user-${Date.now()}`,
      sender: "user",
      body: messageInput,
      time: getTime(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setMessageInput("");
    scrollToBottom();
    setLoading(true);



    await sendChat(messageInput);
    setLoading(false);
  };

  useEffect(() => {
    const fetchChatHistory = async () => {
      try {
        const res: any = await CallAPIGetPromise(`/api/tradesmensAI/chat-history/${userId}`);
        if (res.success) {
          if(res.messages[0]){
            setIsHomerOwnerStepCompleted(true)
          }
          const chatMessages: Message[] = res.messages.map((msg: any, index: number) => {
            if(msg.role ==="user"){
              if( msg.message.includes("Selected SubContractor")){
                setAwaitingSubContractrSelection(false)
              }
              return ({
                id: `msg-${index}`,
                sender: msg.role === "user" ? "user" : "ai",
                body: msg.message,
                time: getTime(), // optional: could use msg.created_at
              })
            }else{
              const parsedReply = JSON.parse(msg.message);
                    if(parsedReply?.type==="text"){
                      return  {
                            id: `ai-${Date.now()}`,
                            sender: "ai",
                            body: parsedReply.message,
                            time: getTime(),
                      }
                    }
                    if(parsedReply.type === "trigger" &&parsedReply.message  === "TRIGGER_SHOW_CONTRACT_SUMMARY"){
                      return  {
                        id: `ai-json-${Date.now()}`,
                        sender: "ai",
                        body: `📄 Here's your contract summary:\n\n\`\`\`json\n${JSON.stringify(
                          res.data.contract,
                          null,
                          2
                        )}\n\`\`\``,
                        time: getTime(),
                      };
                    }else{
                        if(parsedReply.type === "trigger" &&parsedReply.message  === "TRIGGER_SEARCH_SUBCONTRACTOR"){
                        setAwaitingSubContractrSelection(true)
                        return  {
                          id: `ai-json-${Date.now()}`,
                          sender: "ai",
                          body: `Select SubContractor`,
                          time: getTime(),
                        };
                      }
                    }
                
            }
          });
  
          setMessages([
            {
              id: "welcome",
              sender: "ai",
              body:
                "👋 Hey! I’ll help you generate a contract. Let’s start with the homeowner’s name or email. Or type 'skip' if you want to add it later.",
              time: getTime(),
            },
            ...chatMessages,
          ]);
        }
      } catch (err) {
        console.error("Failed to fetch chat history:", err);
      }
    };
  
    if (userId) {
      fetchChatHistory();
    }
  }, [userId]);

  const creatNewChat = ()=>{
    CallAPIGetPromise(`/api/tradesmensAI/delete-chat-history/${userId}`).then((res:any)=>{
      if(res.success){
        setMessages([
          {
            id: "welcome",
            sender: "ai",
            body: "👋 Hey! I’ll help you generate a contract. Let’s start with the homeowner’s name or email. Or type 'skip' if you want to add it later.",
            time: getTime(),
          },
        ]);
        setIsHomerOwnerStepCompleted(false)
      }

    })
  }
  
  return (
    <div className="page-content contract-flow-page contract-ai-page tailwind-prefix bg-gray-50 min-h-screen">
      <Container fluid style={{ padding: 0 }}>
        <div className="overflow-hidden flex flex-col h-[80vh]">
          {/* Chat header */}
          <div className="flex bg-white p-2 items-center">
            <div className="w-[40px] flex items-center justify-center text-white text-[19px] h-[40px] rounded-full bg-[#AA9EE8]">
              AI
            </div>
            <div className="flex justify-between flex-1 items-center">
            <div className="ml-3">
              <div className="text-[18px] text-gray-800 font-semibold">Logan</div>
              <div className="text-gray-500">Online</div>
            </div>

            <div onClick={()=>{
              creatNewChat()
            }} className="bg-blue-200 cursor-pointer py-2 px-3 rounded-md ">
              New Chat
            </div>

            </div>
           
          </div>

          {/* Chat body */}
          <div className="flex-1 overflow-hidden">
            <SimpleBar className="h-full px-6 py-4">
              <ul className="space-y-5">
                {messages.map((msg) => (
                  <li key={msg.id} className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}>
                    <div className="flex items-start space-x-3 max-w-[75%]">
                      <div>
                        <div
                          className={`px-3 py-3 rounded-2xl text-sm leading-relaxed shadow-sm ${
                            msg.sender === "user"
                              ? "bg-blue-600 text-white rounded-br-none"
                              : "bg-[#E8E8E8] text-gray-800 rounded-bl-none"
                          }`}
                        >
                          {msg.body}
                          <div className="flex justify-end text-gray-400 mt-1">{msg.time}</div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
                <div ref={messagesEndRef} />
                {!isHomeownerStepCompleted && (
  <div className="">
    <div className="text-gray-700 font-semibold mb-3">Choose how you want to proceed:</div>

    <div className="grid grid-cols-2 gap-4 max-w-[500px]">
      {[
        {
          type: 'Search Homeowner',
          icon: 'bi-search',
          color: 'bg-blue-50',
          iconColor: 'text-blue-600',
        },
        {
          type: 'Skip',
          icon: 'bi-skip-forward-fill',
          color: 'bg-green-50',
          iconColor: 'text-green-600',
        },
      ].map(({ type, icon, color, iconColor }) => (
        <div
          key={type}
          onClick={() => {
            if (type === 'Skip') {
            } else {
              setShowHomeownerModal(true)
            }
          }}
          className={`flex items-center gap-3 px-3 py-2 rounded-xl ${color} border border-gray-200 shadow hover:shadow-md hover:bg-opacity-90 transition-all duration-200 cursor-pointer`}
        >
          <i className={`bi ${icon} ${iconColor} text-xl`}></i>
          <span className="text-sm font-medium text-gray-800">{type}</span>
        </div>
      ))}
    </div>
  </div>
)}


{isAwaitingSubContractrSelection && (
  <div className="">
    <div className="text-gray-700 font-semibold mb-3">Choose how you want to proceed:</div>

    <div className="grid grid-cols-2 gap-4 max-w-[500px]">
      {[
        {
          type: 'Search SubContractor',
          icon: 'bi-search',
          color: 'bg-blue-50',
          iconColor: 'text-blue-600',
        },
        {
          type: 'Skip',
          icon: 'bi-skip-forward-fill',
          color: 'bg-green-50',
          iconColor: 'text-green-600',
        },
      ].map(({ type, icon, color, iconColor }) => (
        <div
          key={type}
          onClick={() => {
            if (type === 'Skip') {
            } else {
              setShowSubContractorModal(true)
            }
          }}
          className={`flex items-center gap-3 px-3 py-2 rounded-xl ${color} border border-gray-200 shadow hover:shadow-md hover:bg-opacity-90 transition-all duration-200 cursor-pointer`}
        >
          <i className={`bi ${icon} ${iconColor} text-xl`}></i>
          <span className="text-sm font-medium text-gray-800">{type}</span>
        </div>
      ))}
    </div>
  </div>
)}

              </ul>
            </SimpleBar>
          </div>

          {/* Homeowner search input */}
   

          {/* Chat input */}
          <div className="border-t bg-white px-6 py-4 flex items-center">
            <input
              type="text"
              placeholder="Type your message..."
              value={messageInput}
              onChange={(e) => setMessageInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              className="flex-1 border border-gray-300 rounded-xl px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <button
              onClick={sendMessage}
              disabled={loading||!isHomeownerStepCompleted}
              className="ml-3 px-4 py-2 rounded-xl bg-blue-600 text-white text-sm hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send"}
            </button>
          </div>
        </div>
        <HomeownerSearchModal
  show={showHomeownerModal}
  onClose={() => setShowHomeownerModal(false)}
  onSelect={(homeowner) => {
    handleHomeownerSelect(homeowner); // your existing logic
  }}
/>

<SubContractorSelection
  show={showSubContractorModal}
  onClose={() => setShowSubContractorModal(false)}
  onSelect={(homeowner) => {
    hanldeSubContractorSelection(homeowner); // your existing logic
  }}
/>
      </Container>
    </div>
  );
};

export default AIContractChatScreen;
